import React from 'react';
import { withRouter } from 'react-router-dom';
import { Visibility, Edit } from '@mui/icons-material';
import IconButton from '@mui/material/IconButton';
import { LinearProgress } from '@mui/material';
import encodeBase64 from '../../../utils/encodeBase64';
import '../../../stylesheets/stylesLayout/cardHotelProperties.scss';
import useUserProfile from '../../../customHooks/useUserProfile';
import Tooltip from '../../../muiComponents/Tooltip';
import Card from '../../../muiComponents/Card';
import Icon from '../../../muiComponents/Icon';

function CardProperty({ HotelName, Imagen, Porcentage, history, Id, key }) {
    const IdEncode = encodeBase64(Id);
    const { readOnlyUser } = useUserProfile();

    const imageStyle = {
        backgroundImage: `url(${Imagen})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center center',
    };

    const handleEditHotel = () => {
        history.push(`/your-property/${IdEncode}`);
    };

    return (
        <Card
            className='card__property__container'
            onClick={handleEditHotel}
            data-id={Id}
            key={key}
        >
            <div className='card__property__container--image'>
                <div className='card__property__container--edit'>
                    <IconButton
                        onClick={handleEditHotel}
                        aria-label='edit'
                        sx={{
                            position: 'absolute',
                            right: 15,
                            top: 15,
                            backgroundColor: `var(--background-transparent-50)`,
                        }}
                        size='small'
                    >
                        {readOnlyUser ? <Visibility /> : <Edit />}
                    </IconButton>
                </div>
                {Imagen ? (
                    <div
                        alt='hotel image'
                        className='hotel__image'
                        style={imageStyle}
                    />
                ) : (
                    <div className='hotel__image__placeholder-container'>
                        <Icon
                            iconName='Apartment'
                            className='hotel__image__placeholder'
                        />
                    </div>
                )}
            </div>
            <LinearProgress
                sx={{ margin: '20px 0' }}
                variant='determinate'
                value={Porcentage}
            />
            <div className='card__property__container--name__hotel '>
                <Tooltip title={HotelName}>
                    <p className=' text-overflow-ellipsis'>{HotelName}</p>
                </Tooltip>
            </div>
        </Card>
    );
}

export default withRouter(CardProperty);
